import type { VideoGuidanceImages } from './videoGuidanceImages.types';

export const VIDEO_GUIDANCE_IMAGES: VideoGuidanceImages = {
  'cs': {
    appleEedShare: { uri: new URL('./video-guidance/cs/apple-eed-share-video.png', import.meta.url).href },
    googleElsShare: { uri: new URL('./video-guidance/cs/android-share-video.png', import.meta.url).href },
    webAppSms: { uri: new URL('./video-guidance/cs/webapp-sms-link.png', import.meta.url).href },
    webAppCamera: { uri: new URL('./video-guidance/cs/webapp-allow-camera.png', import.meta.url).href },
    webAppLocation: { uri: new URL('./video-guidance/cs/webapp-allow-location.png', import.meta.url).href },
  },
  'de': {
    appleEedShare: { uri: new URL('./video-guidance/de/apple-eed-share-video.png', import.meta.url).href },
    googleElsShare: { uri: new URL('./video-guidance/de/android-share-video.png', import.meta.url).href },
    webAppSms: { uri: new URL('./video-guidance/de/webapp-sms-link.png', import.meta.url).href },
    webAppCamera: { uri: new URL('./video-guidance/de/webapp-allow-camera.png', import.meta.url).href },
    webAppLocation: { uri: new URL('./video-guidance/de/webapp-allow-location.png', import.meta.url).href },
  },
  'de-at': {
    appleEedShare: { uri: new URL('./video-guidance/de-AT/apple-eed-share-video.png', import.meta.url).href },
    googleElsShare: { uri: new URL('./video-guidance/de-AT/android-share-video.png', import.meta.url).href },
    webAppSms: { uri: new URL('./video-guidance/de-AT/webapp-sms-link.png', import.meta.url).href },
    webAppCamera: { uri: new URL('./video-guidance/de-AT/webapp-allow-camera.png', import.meta.url).href },
    webAppLocation: { uri: new URL('./video-guidance/de-AT/webapp-allow-location.png', import.meta.url).href },
  },
  'en': {
    appleEedShare: { uri: new URL('./video-guidance/en/apple-eed-share-video.png', import.meta.url).href },
    googleElsShare: { uri: new URL('./video-guidance/en/android-share-video.png', import.meta.url).href },
    webAppSms: { uri: new URL('./video-guidance/en/webapp-sms-link.png', import.meta.url).href },
    webAppCamera: { uri: new URL('./video-guidance/en/webapp-allow-camera.png', import.meta.url).href },
    webAppLocation: { uri: new URL('./video-guidance/en/webapp-allow-location.png', import.meta.url).href },
  },
  'fr': {
    appleEedShare: { uri: new URL('./video-guidance/fr/apple-eed-share-video.png', import.meta.url).href },
    googleElsShare: { uri: new URL('./video-guidance/fr/android-share-video.png', import.meta.url).href },
    webAppSms: { uri: new URL('./video-guidance/fr/webapp-sms-link.png', import.meta.url).href },
    webAppCamera: { uri: new URL('./video-guidance/fr/webapp-allow-camera.png', import.meta.url).href },
    webAppLocation: { uri: new URL('./video-guidance/fr/webapp-allow-location.png', import.meta.url).href },
  },
  'hu': {
    appleEedShare: { uri: new URL('./video-guidance/hu/apple-eed-share-video.png', import.meta.url).href },
    googleElsShare: { uri: new URL('./video-guidance/hu/android-share-video.png', import.meta.url).href },
    webAppSms: { uri: new URL('./video-guidance/hu/webapp-sms-link.png', import.meta.url).href },
    webAppCamera: { uri: new URL('./video-guidance/hu/webapp-allow-camera.png', import.meta.url).href },
    webAppLocation: { uri: new URL('./video-guidance/hu/webapp-allow-location.png', import.meta.url).href },
  },
  'it': {
    appleEedShare: { uri: new URL('./video-guidance/it/apple-eed-share-video.png', import.meta.url).href },
    googleElsShare: { uri: new URL('./video-guidance/it/android-share-video.png', import.meta.url).href },
    webAppSms: { uri: new URL('./video-guidance/it/webapp-sms-link.png', import.meta.url).href },
    webAppCamera: { uri: new URL('./video-guidance/it/webapp-allow-camera.png', import.meta.url).href },
    webAppLocation: { uri: new URL('./video-guidance/it/webapp-allow-location.png', import.meta.url).href },
  },
  'nl': {
    appleEedShare: { uri: new URL('./video-guidance/nl/apple-eed-share-video.png', import.meta.url).href },
    googleElsShare: { uri: new URL('./video-guidance/nl/android-share-video.png', import.meta.url).href },
    webAppSms: { uri: new URL('./video-guidance/nl/webapp-sms-link.png', import.meta.url).href },
    webAppCamera: { uri: new URL('./video-guidance/nl/webapp-allow-camera.png', import.meta.url).href },
    webAppLocation: { uri: new URL('./video-guidance/nl/webapp-allow-location.png', import.meta.url).href },
  },
  'ro': {
    appleEedShare: { uri: new URL('./video-guidance/ro/apple-eed-share-video.png', import.meta.url).href },
    googleElsShare: { uri: new URL('./video-guidance/ro/android-share-video.png', import.meta.url).href },
    webAppSms: { uri: new URL('./video-guidance/ro/webapp-sms-link.png', import.meta.url).href },
    webAppCamera: { uri: new URL('./video-guidance/ro/webapp-allow-camera.png', import.meta.url).href },
    webAppLocation: { uri: new URL('./video-guidance/ro/webapp-allow-location.png', import.meta.url).href },
  },
  'ro-md': {
    appleEedShare: { uri: new URL('./video-guidance/ro-MD/apple-eed-share-video.png', import.meta.url).href },
    googleElsShare: { uri: new URL('./video-guidance/ro-MD/android-share-video.png', import.meta.url).href },
    webAppSms: { uri: new URL('./video-guidance/ro-MD/webapp-sms-link.png', import.meta.url).href },
    webAppCamera: { uri: new URL('./video-guidance/ro-MD/webapp-allow-camera.png', import.meta.url).href },
    webAppLocation: { uri: new URL('./video-guidance/ro-MD/webapp-allow-location.png', import.meta.url).href },
  },
  'sk': {
    appleEedShare: { uri: new URL('./video-guidance/sk/apple-eed-share-video.png', import.meta.url).href },
    googleElsShare: { uri: new URL('./video-guidance/sk/android-share-video.png', import.meta.url).href },
    webAppSms: { uri: new URL('./video-guidance/sk/webapp-sms-link.png', import.meta.url).href },
    webAppCamera: { uri: new URL('./video-guidance/sk/webapp-allow-camera.png', import.meta.url).href },
    webAppLocation: { uri: new URL('./video-guidance/sk/webapp-allow-location.png', import.meta.url).href },
  },
};
